import { render, staticRenderFns } from "./EduCourseCharpterStudyrecord.vue?vue&type=template&id=18b0aa0e&scoped=true"
import script from "./EduCourseCharpterStudyrecord.vue?vue&type=script&lang=js"
export * from "./EduCourseCharpterStudyrecord.vue?vue&type=script&lang=js"
import style0 from "./EduCourseCharpterStudyrecord.vue?vue&type=style&index=0&id=18b0aa0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0aa0e",
  null
  
)

export default component.exports